import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Record } from '../shared/models/record.model';
import { CountAndResults, LabelsAndData, MonthsAvg, RecordComment, RecordSearch, StatsBody, StatsFollowers } from '../shared/types';

@Injectable({
  providedIn: 'root'
})
export class RecordService {
  private http = inject(HttpClient);


  add(record: Record): Observable<void> {
    return this.http.post<void>('/api/record', record);
  }

  search(body: RecordSearch): Observable<CountAndResults> {
    return this.http.post<CountAndResults>('/api/records/search', body);
  }

  get(id: string): Observable<Record> {
    return this.http.get<Record>(`/api/record/${id}`);
  }

  update(record: Record): Observable<void> {
    return this.http.put<void>(`/api/record/${record._id}`, record);
  }

  delete(record: Record): Observable<void> {
    return this.http.delete<void>(`/api/record/${record._id}`);
  }

  addComment(record: Record, comment: RecordComment): Observable<void> {
    return this.http.post<void>(`/api/record/${record._id}/comment`, comment);
  }

  updateComment(record: Record, comment: RecordComment): Observable<void> {
    return this.http.put<void>(`/api/record/${record._id}/comment`, comment);
  }

  deleteComment(record: Record, commentId: number | string): Observable<void> {
    return this.http.delete<void>(`/api/record/${record._id}/comment/${commentId}`);
  }

  clientSummary(id: string, year: string): Observable<string> {
    return this.http.post<string>(`/api/records/summary/client/${id}`, { year });
  }

  // Stats
  getStatsCounters(body: StatsBody): Observable<MonthsAvg> {
    return this.http.post<MonthsAvg>('/api/record/stats/counters', body);
  }

  getStatsByActivity(body: StatsBody): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/activity', body);
  }

  getStatsByClient(body: StatsBody): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/client', body);
  }

  getStatsByCluster(body: StatsBody): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/cluster', body);
  }

  getStatsByUser(body: StatsBody): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/user', body);
  }

  getStatsByDepartment(body: StatsBody): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/department', body);
  }

  getStatsByStakeholder(body: StatsBody): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/politician', body);
  }

  getStatsByParty(body: StatsBody): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/party', body);
  }

  getStatsByMedia(body: StatsBody): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/media', body);
  }

  getStatsByCommission(body: StatsBody): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/commission', body);
  }

  getStatsByWeek(body: StatsBody): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/week', body);
  }

  getStatsByFollowers(body: StatsFollowers): Observable<LabelsAndData> {
    return this.http.post<LabelsAndData>('/api/record/stats/followers', body);
  }

}
